import { createContext } from 'react'

const UIContext = createContext();
export default UIContext;